import React, { useContext } from "react";
import styled, { ThemeContext, css } from "styled-components";
import { Device } from "../../../../helpers/screenSizes";
import { NavigationProps } from "../types/navigation";
import { MobileMenuIcon } from "../../shared/MobileMenuIcon";
import { InternalLink } from "../../../link/InternalLink";
import { colors } from "../../../../styles/variables";

const StyledMobileMenu = styled.div`
  @media ${Device.notMobile} {
    display: none;
  }

  display: flex;
  flex-direction: column;
`;

const StyledMenu = styled.div<{ isMenuOpen: boolean }>`
  @media ${Device.mobile} {
    ${({ isMenuOpen }) => !isMenuOpen && `display: none;`};
    ${({ isMenuOpen }) =>
      isMenuOpen &&
      css`
        z-index: 1;
        background-color: ${({ theme }) => theme.color.disabled};
        color: ${({ theme }) => theme.color.primary};
        position: fixed;
        height: 100%;
        width: 100%;
        left: 0;
        top: 60px;
        display: flex;
        flex-direction: column;
      `};
  }
`;

const StyledLink = styled.div`
  color: ${({ theme }) =>
    theme.header?.portal?.mobileLinkColor || theme.color.primary};
  background-color: ${({ theme }) =>
    theme.header?.portal?.backgroundColor || "#fff"};
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  border-bottom: 1px solid #ebebeb;
`;

interface MobileMenuProps extends NavigationProps {
  isMenuOpen: boolean;
  setMenuOpen: (isOpen: boolean) => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = (props) => {
  const theme = useContext(ThemeContext);
  return (
    <StyledMobileMenu>
      <MobileMenuIcon
        isOpen={props.isMenuOpen}
        onClick={() => props.setMenuOpen(!props.isMenuOpen)}
        color={theme.header?.portal?.navLinkColor || colors.white}
      />
      <StyledMenu isMenuOpen={props.isMenuOpen}>
        {props.links?.map((link) => {
          const { position, title, url } = link;
          return (
            <InternalLink
              key={position}
              href={url}
              onClick={() => props.setMenuOpen(false)}
            >
              <StyledLink>{title}</StyledLink>
            </InternalLink>
          );
        })}
      </StyledMenu>
    </StyledMobileMenu>
  );
};
